import styled from "styled-components";

export const StepperStyled = styled("div")<{
    fullWidth: boolean;
}>`
    display: flex;
    justify-content: center;
    width: ${({ fullWidth }) => (fullWidth ? "100%" : "fit-content")};
`;

export const StepWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    column-gap: 1.5rem;
`;
